export default __webpack_public_path__ + "static/media/Screen-Icon.388ccbbe.svg";